var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6009 4.41076C15.9264 4.7362 15.9264 5.26384 15.6009 5.58928L5.60093 15.5893C5.2755 15.9147 4.74786 15.9147 4.42242 15.5893C4.09699 15.2638 4.09699 14.7362 4.42242 14.4108L14.4224 4.41076C14.7479 4.08533 15.2755 4.08533 15.6009 4.41076Z",
    fill: "#2A2D31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42242 4.41076C4.74786 4.08533 5.2755 4.08533 5.60093 4.41076L15.6009 14.4108C15.9264 14.7362 15.9264 15.2638 15.6009 15.5893C15.2755 15.9147 14.7479 15.9147 14.4224 15.5893L4.42242 5.58928C4.09699 5.26384 4.09699 4.7362 4.42242 4.41076Z",
    fill: "#2A2D31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.84737e1a05e6c04744dfbe5edc74da7b.svg";
export { ForwardRef as ReactComponent };